import React, { useState } from 'react';
import Cookies from 'js-cookie';

const PhoneVerification = ({ domain, onVerified }) => {
  const [managerPhoneNumber, setManagerPhoneNumber] = useState('');
  const [verificationCode, setVerificationCode] = useState('');
  const [showCodeInputBox, setShowCodeInputBox] = useState(false);

  const generateVerificationCode = async (phone) => {
    try {
      const response = await fetch(`${domain}/site_api/phone_verification_code/generate_new/${phone}`);
      const result = await response.json();
      if (result.success) {
        alert('קוד האימות נשלח אליך ב  SMS או מחכה לך בעזרן, במספר 033765432 או 023765432');
      } else {
        alert('הייתה בעיה בשליחת קוד האימות, נסה שוב');
      }
    } catch (error) {
      console.error('Error:', error);
      alert('הייתה בעיה בשליחת קוד האימות, נסה שוב');
    }
  };

  const handlePhoneSubmit = async (e) => {
    e.preventDefault();
    if (managerPhoneNumber) {
      await generateVerificationCode(managerPhoneNumber);
      setShowCodeInputBox(true);
    } else {
      alert('אנא מלא את מספר הטלפון');
    }
  };

  const handleVerificationSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch(`${domain}/site_api/phone_verification_code/verify/${managerPhoneNumber}/${verificationCode}`);
      const result = await response.json();
      if (result.success) {
        const token = result.token;
        // שמירת האסימון והטלפון בקוקיס
        Cookies.set('phoneNumber', managerPhoneNumber, { expires: 1/24 });
        Cookies.set('verificationToken', token, { expires: 1/24 });
        alert('הטלפון אומת בהצלחה');
        onVerified(); // עדכון שהאימות הצליח
      } else {
        alert('קוד האימות אינו נכון, נסה שוב');
      }
    } catch (error) {
      console.error('Error:', error);
      alert('הייתה בעיה באימות הטלפון, נסה שוב');
    }
  };

  return (
    <div style={{ maxWidth: '400px', margin: '50px auto', padding: '20px', backgroundColor: 'white', borderRadius: '8px', textAlign: 'center' }}>
      <h2>אימות טלפון</h2>
      {!showCodeInputBox ? (
        <form onSubmit={handlePhoneSubmit}>
          <div className="form-group">
            <label>טלפון לניהול הממשק:</label>
            <input
              type="text"
              value={managerPhoneNumber}
              onChange={(e) => setManagerPhoneNumber(e.target.value)}
              required
            />
          </div>
          <button type="submit">שלח קוד אימות</button>
        </form>
      ) : (
        <form onSubmit={handleVerificationSubmit}>
          <div className="form-group">
            <label>אנא הזן את קוד האימות שקיבלת:</label>
            <input
              type="text"
              value={verificationCode}
              onChange={(e) => setVerificationCode(e.target.value)}
              required
            />
          </div>
          <button type="submit">אמת טלפון</button>
        </form>
      )}
    </div>
  );
};

export default PhoneVerification;
